import React from 'react';
import { Row, Form, Button, Col } from 'react-bootstrap';
import { addCustomer } from '../../services/customer';
import { addNotification } from '../../action/notificationAction';
import { CompanyForm } from './CompanyForm';
import UserForm from './UserForm';
import { TenantForm } from './TenantForm';
import Loader from '../loader';


/**Controller component which handles the adding of a company */
export default class AdminCenter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            amountOfCustomers: 0,
            companyObject: {
                company: "",
                tenantUsers: [], demoUsers: [],
                tenantDetails: {
                    tenant: "",
                    sharepointURL: "",
                    username: "",
                    clientId: ""
                }
            }
        };
    }
    componentDidMount() {
        // getPublishedTrees();
    }
    componentWillMount() {

    }
    componentWillUnmount() {

    }
    /**Submits the tenant data thats been entered
     * check if any of the info is empty/missing
     * then fires off to the api
     */
    submit = () => {
        const companyObj = JSON.stringify(this.state.companyObject);
        const companyObject = JSON.parse(companyObj);
        const errors = [];
        if (!companyObject.company) {
            errors.push("Company name");
        }
        if (!companyObject.tenantDetails) {
            errors.push("demo tenant info");
        }
        if (companyObject.tenantDetails) {
            if (!companyObject.tenantDetails.tenant) {
                errors.push("Tenant");
            }
            if (!companyObject.tenantDetails.clientId) {
                errors.push("client id");
            }
        }
        if (errors.length > 0) {
            let string = errors.join(", ");
            addNotification({ status: "fail", message: `The following entries need to be added: ${string}` });
            // return;
        } else {

            if (companyObject.tenantUsers.length === 0) {
                if (!window.confirm("Are you sure you want to add no users")) {
                    return;
                }
            }
            this.setState({ loading: true });
            addCustomer(companyObject).then((res) => {
                addNotification({ status: "success", message: "Successfully created the customer" });
                this.setState({
                    loading: false,
                    companyObject: {
                        company: "",
                        tenantUsers: [], demoUsers: [],
                        tenantDetails: {
                            tenant: "",
                            sharepointURL: "",
                            username: "",
                            clientId: ""
                        }
                    },
                    amountOfCustomers: 0
                });
            }).catch((e) => {
                this.setState({ loading: false });
                if (e === 401) {
                    addNotification({ status: "fail", message: "You are not a admin, do not try again" });
                    this.props.notAdmin();
                } else {
                    addNotification({ status: "fail", message: e });
                }
            });
        }

    };
    /**Set the company state */
    setCompany = (companyName) =>
        this.setState((prevState) => ({
            companyObject: { ...prevState.companyObject, company: companyName }
        }));
    /**Handles the adding and removing UI of users for the customer */
    amountOfCustomers = (type) => {
        if (type === "add") {
            this.setState((prevState) => ({
                amountOfCustomers: prevState.amountOfCustomers + 1
            }));
        } else if (type === "remove" && this.state.amountOfCustomers > 0) {
            this.setState((prevState) => ({
                amountOfCustomers: prevState.amountOfCustomers - 1
            }));
        }
    };
    /**Handles adding a customer, checks if there is already an array,
     * checks if its already in the list
     */
    addUser = (email, id, typeOfUser) => {
        if (this.state.companyObject[typeOfUser]) {
            const exists = this.state.companyObject[typeOfUser].filter((user) => user.id === id);
            if (exists.length === 0) {
                this.setState((prevState) => ({
                    companyObject: {
                        ...prevState.companyObject,
                        [typeOfUser]: prevState.companyObject[typeOfUser].concat({ id: id, email: email })
                    }
                }));
            } else {
                if (exists[0].email === email) {
                    return;
                } else {
                    const index = this.state.companyObject[typeOfUser].indexOf(exists[0]);
                    let users = this.state.companyObject[typeOfUser];
                    users[index] = { id: id, email: email };
                    this.setState((prevState) => ({
                        companyObject: { ...prevState.companyObject, [typeOfUser]: users }
                    }));
                }
            }
        }
    };
    /**Handler for tenant detail */
    addTenant = (objectName, objectValue) =>
        this.setState((prevState) => ({
            companyObject: {
                ...prevState.companyObject,
                tenantDetails: {
                    ...prevState.companyObject.tenantDetails, [objectName]: objectValue
                }
            }
        }));
    /**removes the users from the list when you remove the UI component */
    removeCustomerComponent = (id) => {
        const exists = this.state.companyObject.tenantUsers.filter((user) => user.id === id);
        if (exists.length === 0) {
            return;
        } else {
            const index = this.state.companyObject.tenantUsers.indexOf(exists[0]);
            let users = this.state.companyObject.tenantUsers.splice(index, 1);
            this.setState((prevState) => ({
                companyObject: { ...prevState.companyObject, tenantUsers: users }
            }));
        }
    };
    render() {
        const { companyObject, loading } = this.state;
        if (loading) {
            return <Loader />;
        }
        const users = [];
        for (let i = 0; i < this.state.amountOfCustomers; i++) {
            users.push(<UserForm key={i} id={i} addUser={this.addUser}
                type="tenantUsers" removeOnUnmount={this.removeCustomerComponent}
                userData={companyObject.tenantUsers[i] ? companyObject.tenantUsers[i].email : undefined} />);
        }
        if (users.length > 0) {
            users.unshift(<h6>Login users</h6>);
        }
        return (
            <div>
                <h4>Create Company & Users</h4>
                <Row>
                    <Col xs={6}>
                        <CompanyForm company={companyObject.company}
                            setCompany={this.setCompany} />
                    </Col>
                    <Col xs={6}>
                        <br />
                        <Form.Label>Add a user</Form.Label>&nbsp;
                        <Button variant="outline-success" onClick={() => this.amountOfCustomers("add")}>+</Button>&nbsp;
                        <Button variant="outline-danger" onClick={() => this.amountOfCustomers("remove")}>-</Button>&nbsp;
                        {/* </div> */}
                    </Col>
                </Row>
                <TenantForm setTenant={this.addTenant}
                    tenantData={companyObject.tenantDetails ? companyObject.tenantDetails : undefined}
                    tenantType="demoTenant" />
                <h6>Demo tenant users</h6>
                <Row>
                    <Col xs={6}>
                        <UserForm key={"demo1"} id={1} addUser={this.addUser}
                            type="demoUsers" removeOnUnmount={this.removeCustomerComponent}
                            userData={companyObject.tenantUsers[0] ? companyObject.tenantUsers[0].email : undefined}
                        />
                    </Col>
                    <Col xs={6}>
                        <UserForm key={"demo1"} id={2} addUser={this.addUser}
                            type="demoUsers" removeOnUnmount={this.removeCustomerComponent}
                            userData={companyObject.tenantUsers[1] ? companyObject.tenantUsers[1].email : undefined}
                        />
                    </Col>
                </Row>

                {/* <TenantForm setTenant={this.addTenant}
                    tenantData={companyObject.liveTenant ? companyObject.liveTenant : undefined}
                    tenantType="liveTenant" /> */}
                <br />
                {users}
                <br />
                <Button size="lg" variant="success" className="pull-right" onClick={this.submit}> Submit Customer Data</Button>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/adminCenter/AdminCenter.js